<!-- <div class="list-options">
  <div class="mb-20" flFlex flexLayout="row" flexLayout.lt-md="column">
    <div fxFlex>
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="position">
          <th mat-header-cell *matHeaderCellDef>No.</th>
          <td mat-cell *matCellDef="let element">{{ element.position }}</td>
        </ng-container>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let element">{{ element.name }}</td>
        </ng-container>
        <ng-container matColumnDef="weight">
          <th mat-header-cell *matHeaderCellDef>Weight</th>
          <td mat-cell *matCellDef="let element">{{ element.weight }}</td>
        </ng-container>
        <ng-container matColumnDef="symbol">
          <th mat-header-cell *matHeaderCellDef>Symbol</th>
          <td mat-cell *matCellDef="let element">{{ element.symbol }}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>
</div>

<div class="list-options">
  <div class="mb-20" fxLayout="row" fxLayout.lt-md="column" fxFlex fxLayoutGap="20px">
    <div fxFlex *ngFor="let item of places">
      <mat-card>
        <img mat-card-image [src]="item.imgSrc" />
        <mat-card-header style="justify-content: center">
          <mat-card-title>
            <h3 class="m-0">{{ item.place }}</h3>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>
            {{ item.description }}
          </p>
        </mat-card-content>

        <mat-card-actions>
          <button mat-button>{{ item.charge }}</button>
          <button mat-button><mat-icon class="nav-icon">location_on</mat-icon> {{ item.location }}</button>
        </mat-card-actions>
      </mat-card>
    </div>
  </div>
</div> -->
<router-outlet></router-outlet>
